// AI Generated Component
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { SeoRepoService } from '../../services/seo-repo.service';
import { MonLoadingService } from '@monsido/services/loading/services/loading.service';
import { BaseEntityService } from '@client/app/blocks/base/base.entity.service';
import { ENTITY_CONSTANT } from '@client/app/core/constants/entity.constant';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'seo-dialog-pages-with-duplicate-title',
    templateUrl: './seo-dialog-pages-with-duplicate-title.component.html',
    standalone: false,
})
export class SeoDialogPagesWithDuplicateTitleComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    @Input() issue: any;
    @Input() pageCount: number = 0;

    private destroy$ = new Subject<void>();
    loading = false;

    override currentSort: any = { by: 'title', direction: 'desc' };
    selectedTitle: any = null;
    titles: any = [];
    promise: Promise<any> | null = null;
    exports: any[] = [];
    eventId = 0;

    constructor (
        private seoRepoService: SeoRepoService,
        private loadingService: MonLoadingService,
        private baseEntityService: BaseEntityService,
    ) {
        super({ table: true, labels: true, pages: true });
    }

    ngOnInit (): void {
        // Set up event listener for entity updates
        this.eventId = this.monEventsService.addListener(
            ENTITY_CONSTANT.PAGE_UPDATED_EVENT as any,
            this.baseEntityService.updateEntryInArray(this, 'titles', 'id'),
        );

        // In modal context, data might be passed differently
        // Try to get data from the modal context if inputs are not set
        if (!this.issue || this.pageCount === 0) {
            this.initializeFromModalData();
        }

        // Initialize after inputs are set
        this.initializeComponent();
    }

    ngOnDestroy (): void {
        if (this.eventId) {
            this.monEventsService.remove(this.eventId);
        }
        this.destroy$.next();
        this.destroy$.complete();
    }

    private initializeFromModalData (): void {
        // Check if data is available through the modal context
        // This is a common pattern in hybrid AngularJS/Angular modal systems
        const modalData = (window as any)?.monModalData;
        if (modalData) {
            this.issue = modalData.issue || this.issue;
            this.pageCount = modalData.pageCount || this.pageCount;
        }
    }

    override async getPage (): Promise<void> {
        this.loading = true;
        this.loadingService.show();

        try {
            const params = {
                page: this.page, // Use BaseComponent's page property
                page_size: this.pageSize, // Use BaseComponent's pageSize property
                sort_by: this.currentSort.by,
                sort_dir: this.currentSort.direction,
            };

            this.promise = this.seoRepoService.getIssueContent(this.issue.id, params).then((data) => {
                this.titles = data;
                if (this.titles.length > 0) {
                    this.selectedTitle = this.titles[0];
                } else {
                    this.selectedTitle = null;
                }
                return data;
            }).catch(() => {
                // Handle error silently like original
            });

        } finally {
            this.loading = false;
            this.loadingService.hide();
        }
    }

    private initializeComponent (): void {
        this.currentSort = { by: 'title', direction: 'desc' };
        this.selectedTitle = null;
        this.titles = [];
        this.promise = null;
        this.getPage(); // Use the async getPage method
        this.exports = [
            {
                data: {
                    category: 'seo',
                    category_ref: this.issue.name,
                },
            },
        ];
    }

    getTitles (): void {
        this.getPage();
    }

    onSelectedTitleChange (title: any): void {
        this.selectedTitle = title;
    }

    shouldShowQuickHelp (): boolean {
        return this.issue &&
               this.isNumber(this.pageCount) &&
               typeof this.issue.pages_count === 'number';
    }

    private isNumber (val: any): boolean {
        return typeof val === 'number' && !isNaN(val);
    }
}
